import axios from 'axios'

const cepRequest = axios.create({
  baseURL: 'https://viacep.com.br/ws',
})

export default cepRequest
